<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { RouterLink } from 'vue-router'
import AppIcon from './AppIcon.vue'
import BrandLogo from './BrandLogo.vue'

withDefaults(defineProps<{ minimal?: boolean }>(), { minimal: false })

const links = [
  { to: '/join', label: 'Join a game' },
  { to: '/admin', label: 'Host console' },
  { to: '/install', label: 'Setup' },
]
const scrolled = ref(false)
const menuOpen = ref(false)

function onScroll(): void { scrolled.value = window.scrollY > 45 }
onMounted(() => { window.addEventListener('scroll', onScroll, { passive: true }); onScroll() })
onBeforeUnmount(() => { window.removeEventListener('scroll', onScroll); document.body.classList.remove('body-active') })
watch(menuOpen, (open) => document.body.classList.toggle('body-active', open))
</script>

<template>
  <header
    class="header"
    :class="{ 'sticky-header': scrolled, 'header-alter': minimal }"
  >
    <div class="container container--wide">
      <nav
        class="navbar"
        aria-label="Primary"
      >
        <a
          href="/"
          class="navbar-logo"
          aria-label="Bar Bluff home"
        >
          <BrandLogo />
        </a>
        <template v-if="!minimal">
          <ul class="navbar__list">
            <li
              v-for="link in links"
              :key="link.to"
              class="navbar__item"
            >
              <RouterLink :to="link.to">
                {{ link.label }}
              </RouterLink>
            </li>
          </ul>
          <div class="navbar__options">
            <div class="navbar__cta">
              <slot name="cta" />
            </div>
            <button
              type="button"
              class="open-offcanvas-nav"
              :class="{ 'open-offcanvas-nav-active': menuOpen }"
              aria-label="Open menu"
              :aria-expanded="menuOpen"
              @click="menuOpen = !menuOpen"
            >
              <span class="top-bar" /><span class="middle-bar" /><span class="bottom-bar" />
            </button>
          </div>
        </template>
      </nav>
    </div>
  </header>
  <template v-if="!minimal">
    <div
      class="mobile-menu"
      :class="{ 'show-menu': menuOpen }"
      :aria-hidden="!menuOpen"
    >
      <nav
        class="mobile-menu__wrapper"
        aria-label="Mobile"
      >
        <div class="mobile-menu__header">
          <BrandLogo />
          <button
            type="button"
            class="close-mobile-menu"
            aria-label="Close menu"
            @click="menuOpen = false"
          >
            <AppIcon name="x" />
          </button>
        </div>
        <ul class="navbar__list">
          <li
            v-for="link in links"
            :key="link.to"
            class="navbar__item"
          >
            <RouterLink
              :to="link.to"
              @click="menuOpen = false"
            >
              {{ link.label }}
            </RouterLink>
          </li>
        </ul>
        <div class="mobile-menu__cta">
          <slot name="mobile-cta" />
        </div>
      </nav>
    </div>
    <div
      class="mobile-menu__backdrop"
      :class="{ 'mobile-menu__backdrop-active': menuOpen }"
      @click="menuOpen = false"
    />
  </template>
</template>
